export function checkFullscreen(auth, WebApp) {
    if (!WebApp) return;
    console.info("WebApp.isFullscreen", WebApp.isFullscreen)
    if (auth != "n/a" && auth != null) {
        if (WebApp.isFullscreen) {
            document.body.style.paddingTop = isMobile() ? '85px' : '50px';
        } else {
            document.body.style.paddingTop = '0';
        }
    } else {
        const mainEl = document.querySelector('.main');
        if (!mainEl) return;
        if (WebApp.isFullscreen) {
            mainEl.style.paddingTop = isMobile() ? '85px' : '50px';

        } else {
            mainEl.style.paddingTop = '20px';
        }
    }

}

export function isMobile() {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /mobile|android|iphone|ipad|ipod/.test(userAgent);

    if (isMobile) {
        return true;
    }
    return false;
}
